<template>
  <div class="calendar container-fluid">
    <button class="btn btn-primary mb-1 mt-1" @click="openBreakWindow">
      + Privater Eintrag
    </button>
    <settings-container
      :initial="{ selectedDate: null, selectedDay: undefined }"
    >
      <job-calendar
        slot-scope="{ settings, set }"
        :data-url="config.api.urls.jobs.list"
        :data-src="datesLoaded"
        :loader="loadJobs"
        :set-loaded-data="false"
        :preload-months-previous="3"
        :preload-months-next="3"
        :selected-date="settings.selectedDate"
        :selected-day="settings.selectedDay"
        :editable="false"
        :type-icons="typeIcons"
        :split-by-technician="false"
        @month-changed="
          if ($event.dataLoaded) {
            set({
              selectedDate: null,
              selectedDay: $event.viewChangeData.startDate,
            });
          }
        "
      >
        <template slot="event-content-0">
          <button
            type="button"
            class="btn btn-secondary btn-full-width btn-small default-hover"
            disabled
          >
            Warte auf Bestätigung..
          </button>
        </template>

        <template slot="event-content-10" slot-scope="data">
          <button
            v-if="
              data.date.technicianRequest &&
              data.date.technicianRequest.status == 2
            "
            type="button"
            class="btn btn-primary btn-full-width btn-small default-hover"
            disabled
          >
            {{
              data.date.job.type == app.options.Job.TYPE.servicing
                ? "Serviceauftrag"
                : "Montageauftrag"
            }}
          </button>

          <template
            v-else-if="
              data.date.technicianRequest &&
              data.date.technicianRequest.validUntil < new Date()
            "
          >
            <strong>Annahmefrist abgelaufen</strong>
          </template>

          <template v-else-if="data.date.technicianRequest">
            <small
              >Annahmefrist endet
              {{
                validUntilOutput(data.date.technicianRequest.validUntil)
              }}</small
            >

            <div class="d-flex">
              <button
                type="button"
                class="
                  btn btn-icon btn-auto-width btn-next
                  default-hover
                  flex-fill
                  mr-xxs
                "
                @click="
                  showJobRequestRespondWindow(
                    data.date,
                    app.options.JobTechnicianRequest.STATUS.accepted,
                    $event
                  )
                "
              >
                <img
                  src="~smartdoors-shared/img/icons/check-circle-white.svg"
                />
              </button>
              <button
                type="button"
                class="
                  btn btn-icon btn-auto-width btn-deny
                  default-hover
                  flex-fill
                  mr-xxs
                "
                @click="
                  showJobRequestRespondWindow(
                    data.date,
                    app.options.JobTechnicianRequest.STATUS.rejected,
                    $event
                  )
                "
              >
                <img
                  src="~smartdoors-shared/img/icons/cross-circle-white.svg"
                />
              </button>
            </div>
          </template>
        </template>

        <template slot="event-content-11" slot-scope="data">
          <button
            type="button"
            class="btn btn-primary btn-full-width btn-small default-hover"
            @click="
              $router.push({
                name: 'JobAssemblingDetail',
                params: { jobId: data.date.job.id, jobData: data.date.job },
              })
            "
          >
            {{
              data.date.job.type == app.options.Job.TYPE.servicing
                ? "Serviceauftrag"
                : "Montageauftrag"
            }}
          </button>
        </template>
        <!-- TODO: reuse event content 11/12! -->
        <template slot="event-content-12" slot-scope="data">
          <button
            type="button"
            class="btn btn-primary btn-full-width btn-small default-hover"
            @click="
              $router.push({
                name: 'JobAssemblingDetail',
                params: { jobId: data.date.job.id, jobData: data.date.job },
              })
            "
          >
            {{
              data.date.job.type == app.options.Job.TYPE.servicing
                ? "Serviceauftrag"
                : "Montageauftrag"
            }}
          </button>
        </template>

        <template slot="event-content-20" slot-scope="data">
          <button
            type="button"
            class="btn btn-secondary btn-full-width btn-small btn-icon-left"
            @click="
              $router.push({
                name: 'JobAssemblingDetail',
                params: { jobId: data.date.job.id, jobData: data.date.job },
              })
            "
          >
            <img :src="icon('door.svg')" />
            <span>{{
              __("jobs.components.list.common.buttons.finished")
            }}</span>
          </button>
        </template>

        <template slot="event-content-21" slot-scope="data">
          <button
            type="button"
            class="btn btn-highlighted btn-full-width btn-small btn-icon-left d-block"
            @click="
              $router.push({
                name: 'JobAssemblingDetail',
                params: { jobId: data.date.job.id, jobData: data.date.job },
              })
            "
          >
            <img :src="icon('warning-important.svg')" />
            <span>{{
              __("jobs.components.list.common.buttons.unfinished")
            }}</span>
          </button>
        </template>

        <template slot="event-content-22" slot-scope="data">
          <button
            type="button"
            class="
              btn btn-highlighted btn-full-width btn-small btn-icon-left
              d-block
            "
            @click="
              $router.push({
                name: 'JobAssemblingDetail',
                params: { jobId: data.date.job.id, jobData: data.date.job },
              })
            "
          >
            <img :src="icon('warning-important.svg')" />
            <span>{{
              __("jobs.components.list.common.buttons.cancelled")
            }}</span>
          </button>
        </template>

        <template slot="event-content-break" slot-scope="data">
          <button
            type="button"
            class="btn btn-secondary btn-full-width btn-small btn-icon-left"
            @click="changeBreak(data)"
          >
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <span> Ändern</span>
              <img class="float-right" :src="icon('edit.png')" />
            </div>
          </button>
        </template>
      </job-calendar>
    </settings-container>
  </div>
</template>

<script>
import NeedsJobsLoading from "../mixins/NeedsJobsLoading";
import { requestValidUntilOutput } from "../helper/jobs";
import JobRequestRespondWindow from "../windows/JobRequestRespond";
import CalendarBreakWindow from "../windows/CalendarBreak";
import api from "../helper/api";

export default {
  mixins: [NeedsJobsLoading],
  computed: {
    datesLoaded() {
      let result = [].concat(
        ...this.$store.state.jobs.stacks.current.map((job) =>
          job.dates.map((date) => {
            date.job = job; // set the job object on each date object (needed in the calendar)
            return date;
          })
        )
      );
      if (this.break.length > 0) {
        result = result.concat(this.break); //add the object break date (needed in the calendar)
      }
      // return all dates from the jobs in the 'current' stack of the jobs store
      return result;
    },
    typeIcons() {
      return {
        [this.app.options.JobDate.TYPE.fixed]: this.icon("lock.svg"),
        [this.app.options.JobDate.TYPE.shiftable]: this.icon("shiftable.svg"),
        [this.app.options.JobDate.TYPE.span]: this.icon("span.svg"),
        break: this.icon("dash-circle.svg"),
      };
    },
  },
  created() {
    this.getBreak();
  },
  data() {
    return {
      break: [],
    };
  },
  methods: {
    cnlog: function (data) {},
    async changeBreak(item) {
      const result = await this.$windows.showWindow(CalendarBreakWindow, {
        break_edit: item.date ? item.date : null,
      });

      if (result == "update") {
        this.getBreak();
      }
    },
    async getBreak() {
      const response = await this.api.get("my/break").run();
      this.break = response.data;
    },
    async openBreakWindow($event) {
      const result = await this.$windows.showWindow(CalendarBreakWindow, {
        break_edit: null,
      });

      if (result == "update") {
        this.getBreak();
      }
    },
    /**
     * Show the window for responding to job requests.
     *
     * @param {Object} jobDate The job-date object to respond to
     * @param {Number} status The response status
     */
    showJobRequestRespondWindow(jobDate, status, $event) {
      this.$windows.showWindow(
        JobRequestRespondWindow,
        { job: jobDate.job, date: jobDate, status },
        {},
        { triggerElement: $event.target }
      );
    },
    /**
     * Returns a relative date string for displaying the end of the requests acceptance period of a job.
     *
     * @param {Date} validUntil The valid-until date from the technician request.
     */
    validUntilOutput(validUntil) {
      return requestValidUntilOutput(validUntil);
    },
  },
};
</script>